module.exports = __webpack_public_path__ + "img/icon_develop_02.6ad816e9.png";